<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import Idle from "@/components/traffic-records/idle.vue";
import TrafficRecordComponents from "@/components/traffic-record-components.vue"

export default {
  page: {
    title: "Validate",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "LGU Approval",
      items: [
        {
          text: "Home",
        },
         {
          text: "Traffic Records",
        },
        {
          text: "LGU Approval",
          active: true,
        },
      ],
    };
  },
  components: {
    Layout,
    PageHeader,
    Idle,
    TrafficRecordComponents
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <Idle />
    <TrafficRecordComponents :phase_id="4" />
  </Layout>
</template>
